<template>
  <iVideoContainer
    ref="video"
    :src="videoSrc"
    :height="getOptionValue(LayoutHeight)"
    :min-height="getOptionValue(MinHeight)"
    :max-height="getOptionValue(MaxHeight)"
    :width="getOptionValue(LayoutWidth)"
    :min-width="getOptionValue(MinWidth)"
    :max-width="getOptionValue(MaxWidth)"
    :autoplay="getOptionValue(Autoplay) === 'whenScrolledIntoView'"
    :controls="getOptionValue(Controls)"
    :toggle-on-press="!gestureOwnsTheClick"
    :muted="getOptionValue(Muted)"
    :loop="getOptionValue(Loop)"
    :poster="posterSrc"
    :border-top="myBorderSides?.top ?? 0"
    :border-bottom="myBorderSides?.bottom ?? 0"
    :border-left="myBorderSides?.left ?? 0"
    :border-right="myBorderSides?.right ?? 0"
    :style-overrides="videoStyleOverrides"
  />
</template>

<script>
import { StandardVideoElementMixin } from
  "%/dynamic-component-editor/standard-elements/video-element/standard-video-element-mixin";
import { SingleVideoElementMixin } from "%/dynamic-component-editor/standard-elements/video-element/single-video-element-mixin";

export default {
  name: "VideoElement",
  elementPanelSettings: {
    displayName: "Video",
    elementGroup: "general",
    displayIcon: "video",
    elementType: "element",
  },
  mixins: [StandardVideoElementMixin, SingleVideoElementMixin],
};
</script>

<style scoped lang="scss">
</style>
